import { useMemberPortalNavItems } from "CrossFeatureComponents/MemberToolbar/stateHooks";

export default function useNavMobileBreakpoint() {
  const navItems = useMemberPortalNavItems();
  const numberOfNavItems = Object.keys(navItems).length;

  if (numberOfNavItems >= 4) return 480;

  return 380;
}
